import { wrapPageElement as wrap } from "./wrapper";
    import "./styles/global.css";
    export const wrapPageElement = wrap;